import { useLayoutEffect, useState } from 'react'

const useBodyWidth = () => {
  const [width, setWidth] = useState<number>()

  useLayoutEffect(() => {
    const container = document.body
    if (!container) return
    setWidth(container.offsetWidth)
  }, [])

  return width
}

export default useBodyWidth
